// +----------------------------------------------------------------------
// | Desc:验证库
// +----------------------------------------------------------------------
import Vue from 'vue';


// +----------------------------------------------------------------------
// | Desc:批量验证
// +----------------------------------------------------------------------
// | Param:传入验证值和验证规则批量验证
// +----------------------------------------------------------------------
// | Param:ruleData.type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
// +----------------------------------------------------------------------
// | return:{boolean} true验证通过，false验证不通过
// +----------------------------------------------------------------------
Vue.prototype.$validAll = function (valueData, ruleData) {
    var that = this
    for (let field in ruleData) {
        if (ruleData.hasOwnProperty(field)) {
            var type = ruleData[field].type || "reg";
            //正则验证
            if (type == "reg") {
                regex = ruleData[field].rule;
                var regex = new RegExp(regex);
                if (!regex.test(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //不为空验证
            if (type == "Empty") {
                if (that.$isblank(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //验证对象及对象下层是否为空
            if (type == "objEmpty") {
                if (that.$isblank(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
                for (let key in valueData[field]) {
                    if (valueData[field].hasOwnProperty(key)) {
                        if (that.$isblank(valueData[field][key])) {
                            that.$msg(ruleData[field].message, "warning");
                            return false;
                        };
                        if (key == "address") {
                            if (!that.$isTitle(valueData[field][key])) {
                                that.$msg(ruleData[field].message + "详细地址，必去2-30位且含中文", "warning");
                                return false;
                            };
                        };
                        if (key == "coordinates") {
                            if (!that.$isCoordinates(valueData[field][key])) {
                                that.$msg(ruleData[field].message + "坐标信息", "warning");
                                return false;
                            };
                        };
                    };
                };
            };

            //大于0的正整数验证
            if (type == "id") {
                if (!that.$isId(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //大于0的正整数验证且为-1验证
            if (type == "idEmpty") {
                if (!that.$isIdEmpty(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //2-100位中文验证
            if (type == "title") {
                if (!that.$isTitle(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //2-255位中文验证
            if (type == "note") {
                if (!that.$isNote(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };


            //11位手机号码验证
            if (type == "tel") {
                if (!that.$isTel(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //验证账号或密码
            if (type == "account") {
                if (!that.$isAccount(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //验证是都是大于0的数字
            if (type == "float") {
                if (!that.$isFloat(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //验证是都是大于等于0的金额
            if (type == "price") {
                if (!that.$isPrice(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //验证是都是正、负、0的金额
            if (type == "priceOrFushu") {
                if (!that.$isPriceOrFushu(valueData[field])) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //数量区间验证（数组）
            if (type == "MinMax") {
                var min = ruleData[field].rule.split("-")[0];
                var max = ruleData[field].rule.split("-")[1];
                if (valueData[field].length < min || valueData[field].length > max) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };

            //数量区间验证（1,2,3,4逗号隔开的字符串）
            if (type == "MinMaxStr") {
                var min = ruleData[field].rule.split("-")[0];
                var max = ruleData[field].rule.split("-")[1];
                var value = valueData[field];
                if (this.$isblank(value)) {
                    var arr = [];
                } else {
                    var value = String(value);
                    var arr = value.split(",");
                };
                if (arr.length < min || arr.length > max) {
                    that.$msg(ruleData[field].message, "warning");
                    return false;
                };
            };
        }
    }
    return true;
}


// +----------------------------------------------------------------------
// | Desc:ID验证
// +----------------------------------------------------------------------
Vue.prototype.$isId = function (value) {
    if (this.$isblank(value)) {
        return false;
    };
    const intRegex = /^\d+$/;
    if (!intRegex.test(value.toString())) {
        return false;
    };
    const num = parseInt(value, 10);
    return num > 0 && num < 10000000;
}

// +----------------------------------------------------------------------
// | Desc:ID验证且可为-1
// +----------------------------------------------------------------------
Vue.prototype.$isIdEmpty = function (value) {
    if (this.$isblank(value)) {
        return false;
    };
    if (value == -1) {
        return true;
    };
    const intRegex = /^\d+$/;
    if (!intRegex.test(value.toString())) {

        return false;

    };
    const num = parseInt(value, 10);
    return num > 0 && num < 10000000;
}

// +----------------------------------------------------------------------
// | Desc:是否是电话
// +----------------------------------------------------------------------
Vue.prototype.$isTel = function (phoneNumber) {
    const regex = /^(\d{3,4})?\d{7,8}|(1[3-9]\d{9})$/;
    return regex.test(phoneNumber);
}

// +----------------------------------------------------------------------
// | 必须大于的最多两位小数的数字，且最大不超过10万
// +----------------------------------------------------------------------
Vue.prototype.$isFloat = function (numberInput) {
    const numberRegex = /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
    if (!numberRegex.test(numberInput)) {
        return false;
    }

    const number = parseFloat(numberInput);
    if (isNaN(numberInput)) {
        return false;
    }
    if (number < 0.01) {
        return false;
    }
    if (number > 100000) {
        return false;
    };
    let decimalPart = number.toString().split('.')[1];
    if (decimalPart && decimalPart.length > 2) {
        return false;
    }
    return true;
}

// +----------------------------------------------------------------------
// | Desc:大于等于0的最多两位小数的数字，且最大不超过10万
// +----------------------------------------------------------------------
Vue.prototype.$isPrice = function (numberInput) {
    const numberRegex = /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
    if (!numberRegex.test(numberInput)) {
        return false;
    }
    const number = parseFloat(numberInput);
    if (isNaN(numberInput)) {
        return false;
    }
    if (number > 100000) {
        return false;
    }
    let decimalPart = number.toString().split('.')[1];
    if (decimalPart && decimalPart.length > 2) {
        return false;
    }
    return true;
}

// +----------------------------------------------------------------------
// | Desc: 大于等于-10万且小于等于10万的最多两位小数的数字
// +----------------------------------------------------------------------
Vue.prototype.$isPriceOrFushu = function (numberInput) {
    // 允许负数，并且确保最多只有两位小数
    const numberRegex = /^-?(100000|[1-9]\d{0,4}|0)(\.\d{1,2})?$/;
    if (!numberRegex.test(numberInput)) {
        return false;
    }
    const number = parseFloat(numberInput);
    if (isNaN(number)) {
        return false;
    }
    // 检查数值是否在-10万到10万之间
    if (number < -100000 || number > 100000) {
        return false;
    }
    return true;
};

// +----------------------------------------------------------------------
// | Desc:坐标验证
// +----------------------------------------------------------------------
Vue.prototype.$isCoordinates = function (coordinates) {
    const regex = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
    const matches = coordinates.match(regex);
    if (!matches) {
        return false;
    }
    const latitude = parseFloat(matches[1]);
    const longitude = parseFloat(matches[3]);
    return (latitude >= -90 && latitude <= 90) && (longitude >= -180 && longitude <= 180);
}

// +----------------------------------------------------------------------
// | Desc:验证名称，2到100位,必须是含中文
// +----------------------------------------------------------------------
Vue.prototype.$isTitle = function (inputString) {
    if (inputString == null) {
        return false;
    };
    if (inputString.length < 2 || inputString.length > 100) {
        return false;
    }
    if (!/[\u4e00-\u9fa5]/.test(inputString)) {
        return false;
    }
    return true;
}

// +----------------------------------------------------------------------
// | Desc:验证备注，0到255位,必须是含中文
// +----------------------------------------------------------------------
Vue.prototype.$isNote = function (inputString) {
    if (inputString == null) {
        return true;
    };
    if (inputString.length < 2 || inputString.length > 255) {
        return false;
    }
    if (!/[\u4e00-\u9fa5]/.test(inputString)) {
        return false;
    }
    return true;
}

// +----------------------------------------------------------------------
// | Desc:验证账号或者密码
// +----------------------------------------------------------------------
Vue.prototype.$isAccount = function (str) {
    const regex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]{6,16}$/;
    return regex.test(str);
}


// +----------------------------------------------------------------------
// | Desc:为空验证
// +----------------------------------------------------------------------
// | Param:str 传入的值
// +----------------------------------------------------------------------
// | return:{boolean} true为空，false不为空
// +----------------------------------------------------------------------
Vue.prototype.$isblank = function (value) {
    if (value == null) {
        return true;
    };
    if (value == '') {
        return true;
    };
    if (value == undefined) {
        return true;
    };
    if (value == 'null') {
        return true;
    };
    if (value == 'undefined') {
        return true;
    };
    if (value == '""') {
        return true;
    };
    if (!value || value == 0 || value == '0') {
        return true;
    };
    if (this.$FMT.isNumber(value)) {
        value = this.$FMT.toString(value);
    };
    return this.$FMT.isEmpty(value);
}


// +----------------------------------------------------------------------
// | Desc:是否是url
// +----------------------------------------------------------------------
Vue.prototype.$isUrl = function (str) {
    return this.$verifyRule(str, /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/);
}


// +----------------------------------------------------------------------
// | Desc:是否是中文
// +----------------------------------------------------------------------
Vue.prototype.$isChinese = function (str) {
    return this.$verifyRule(str, /[\u4E00-\u9FA5]/);
}


// +----------------------------------------------------------------------
// | Desc:是否正整数
// +----------------------------------------------------------------------
Vue.prototype.$isPosInt = function (str) {
    return this.$verifyRule(str, /^\d+$/);
}

// +----------------------------------------------------------------------
// | Desc:是否负整数
// +----------------------------------------------------------------------
Vue.prototype.$isNegInt = function (str) {
    return this.$verifyRule(str, /^-\d+$/);
}

// +----------------------------------------------------------------------
// | Desc:是否整数
// +----------------------------------------------------------------------
Vue.prototype.$isInt = function (str) {
    return this.$verifyRule(str, /^-?\d+$/);
}

// +----------------------------------------------------------------------
// | Desc:验证x100的金额
// +----------------------------------------------------------------------
Vue.prototype.$isMoney = function (str) {
    return this.$verifyRule(str, /^(0|[1-9][0-9]*)$/);
}

// +----------------------------------------------------------------------
// | Desc:是否是邮箱
// +----------------------------------------------------------------------
Vue.prototype.$isEmail = function (str) {
    return this.$verifyRule(str, /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
}

// +----------------------------------------------------------------------
// | Desc:自定义正则验证
// +----------------------------------------------------------------------
// | Param:str需要验证的字符
// | Param:rule正则表达式
// +----------------------------------------------------------------------
// | return:{boolean} true通过验证，false不通过验证
// +----------------------------------------------------------------------
Vue.prototype.$verifyRule = function (str, rule) {
    if (this.$isblank(str)) {
        return false;
    };
    if (this.$isblank(rule)) {
        return true;
    };
    var reg = rule;
    return reg.test(str);
}


// +----------------------------------------------------------------------
// | Desc:表格中数据选中验证
// +----------------------------------------------------------------------
Vue.prototype.$isValidTableSelect = function (selectedRows, min, max) {
    // 设置默认值
    min = this.$isblank(min) ? 1 : parseInt(min);
    max = this.$isblank(max) ? 1 : parseInt(max);

    // 确保 min 和 max 是有效的数字
    if (isNaN(min) || isNaN(max)) {
        this.$msg("参数错误：min 和 max 必须是数字", "error");
        return false;
    }

    // 确保 min 不大于 max
    if (min > max) {
        this.$msg("参数错误：min 不能大于 max", "error");
        return false;
    }

    // 获取选中行的数量
    var length = this.$commaToarr(selectedRows, ",").length;


    // 验证选中行的数量
    if (min == max && length != min) {
        this.$msg("请选择" + min + "条数", "warning");
        return false;
    }
    if (length < min) {
        this.$msg("至少需要选中" + min + "条数", "warning");
        return false;
    }
    if (length > max) {
        this.$msg("最多只能选择" + max + "条数据", "warning");
        return false;
    }

    return length;
};


// +----------------------------------------------------------------------
// | 检查是否在 iframe 中
// +----------------------------------------------------------------------
Vue.prototype.$checkIfInIframe = function () {
    if (window.self !== window.top) {
        return true;
    } else {
        return false;
    }
}